import {
  MobileSelectionListItem,
  PaginatedMobileSelectionList,
} from "common/components/MobileSelectionList";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import type { WorkspaceAccount } from "common/types";

import { ACCOUNTS_COLUMNS } from "../../constants";
import AccountName from "../AccountName";
import AccountProfileImage from "../AccountProfileImage";

export default function MobileList({
  accounts,
  selectedAccounts,
  setSelectedAccounts,
}: {
  accounts: WorkspaceAccount[];
  selectedAccounts: WorkspaceAccount[];
  setSelectedAccounts: (selectedAccounts: WorkspaceAccount[]) => void;
}) {
  const { permissions } = useSelectedWorkspaceContext();
  const hasAccountsFullPermission = permissions.includes("accounts_full");

  return (
    <PaginatedMobileSelectionList
      title="Accounts"
      data={accounts}
      localStorageId="accounts"
      selection={selectedAccounts}
      onSelectionChange={
        hasAccountsFullPermission
          ? (newSelection) => {
              if (newSelection === "all") {
                setSelectedAccounts(accounts);
              } else {
                setSelectedAccounts(newSelection);
              }
            }
          : undefined
      }
      allItems={ACCOUNTS_COLUMNS}
    >
      {(account, listItemProps) => (
        <MobileSelectionListItem
          {...listItemProps}
          relativeTo={`accounts/${account.id}`}
        >
          <AccountProfileImage account={account} size="sm" />
          <div className="flex flex-col flex-1">
            <AccountName account={account} className="text-xs-bold" />
            <p className="text-button-xxs text-black-500 line-clamp-1 break-all text-left">
              {account.occupation}
            </p>
          </div>
        </MobileSelectionListItem>
      )}
    </PaginatedMobileSelectionList>
  );
}
